import { styled as n, css as o } from "./styled2.mjs";
const d = n("label")`
	${({ theme: r, $fullWidth: i, $controlPosition: a }) => o`
			display: flex;
			align-items: center;
			flex-direction: ${a === "start" ? "row-reverse" : "row"};
			gap: ${r.spacing(1)};

			min-width: ${r.spacing(37.5)};
			max-width: ${i ? "unset" : r.spacing(75)};
			width: ${i ? "100%" : "auto"};
			min-height: ${r.spacing(10)};

			background: ${r.palette.background.level3};

			padding-block: ${r.spacing(2)};
			padding-left: ${a === "start" ? r.spacing(1.5) : r.spacing(3)};
			padding-right: ${a === "start" ? r.spacing(3) : r.spacing(1.5)};

			cursor: pointer;
		`}

	${({ theme: r, $variant: i }) => {
  if (i === "box")
    return o`
				border: 1px solid ${r.palette.other.divider};
				border-radius: ${r.spacing(1)};
			`;
  if (i === "underlined")
    return o`
				border-bottom: 1px solid ${r.palette.other.divider};
			`;
}};

	${({ theme: r, $hasError: i, $variant: a }) => {
  if (i)
    return a === "box" ? o`
					background: ${r.palette.error.main08};
					border-color: ${r.palette.error.main};
					cursor: pointer;
				` : o`
				color: ${r.palette.error.main};

				p {
					color: ${r.palette.error.main};
				}
			`;
}}
`;
export {
  d as ChoiceBoxLabel
};
//# sourceMappingURL=styles62.mjs.map
